import React, { useState } from "react";
import Calculator from "./components/Calculator"; 
import SupportPage from "./components/SupportPage"; 

const App: React.FC = () => {
  const [showSupportPage, setShowSupportPage] = useState(false);

  return (
    <div>
      {!showSupportPage ? (
        <Calculator onNavigateToSupport={() => setShowSupportPage(true)} />
      ) : (
        <SupportPage onNavigateBack={() => setShowSupportPage(false)} />
      )}
    </div>
  );
};

export default App;
